interface DictionaryItem {
  uid?: string;
}

export function useSpecialOrderUidDictionary<T extends DictionaryItem>(
  dictionaryInput: T[],
) {
  const dictionary = ref<T[]>(dictionaryInput);
  const dictionaryMap = computed<Map<string, T>>(() => {
    const map = new Map<string, T>();
    dictionary.value?.forEach((dictionaryItem) => {
      if (dictionaryItem.uid) {
        map.set(dictionaryItem.uid, dictionaryItem as T);
      }
    });
    return map;
  });

  function setDictionary(dictionaryInput: T[]): void {
    dictionary.value = dictionaryInput as any[];
  }

  function get(key: string): T | undefined {
    return dictionaryMap.value.get(key);
  }

  function collection<K extends Record<string, string>>(
    keys: K,
  ): Record<keyof K, T> {
    return Object.keys(keys).reduce(
      (collection: Record<keyof K, T>, key: keyof K) => {
        const val: T | undefined = get(key as string);
        if (val) {
          collection[key] = val;
        }
        return collection;
      },
      {} as Record<keyof K, T>,
    );
  }

  return {
    dictionary,
    dictionaryMap,
    get,
    collection,
    setDictionary,
  };
}
